/* MLF evening copy, v21, 6 Aug 2026.
   Этот файл раньше был ассетом приложения TinySEO, которое удалило его 1 Aug и оставило в layout/theme.liquid тег script_tag с 404 на каждой странице.
   6 Aug мы положили сюда заглушку (v18), теперь используем её по делу: файл грузится на всех страницах, поэтому в нём живёт общесайтовая подмена текстов после отсечки 17:00 по Нью-Йорку.
   Зачем: вечером обещание same-day становится ложным (Zapiet с 17:00 ставит ближайшую дату на завтра), человек видит одно, а на чекауте другое.
   Меняет только текстовые узлы и только по точным фразам ниже, ничего не удаляет и не трогает разметку.
   Дровер корзины свою полосу меняет сам (v20, snippets/amp-slidecart-edits.liquid), его фразы сюда не входят.
   Откат: вернуть содержимое файла к заглушке или опубликовать предыдущую тему. */
(function () {
  'use strict';
  var PAIRS = [
    ['Hand Delivered Today', 'Hand Delivered Tomorrow'],
    ['Order by 5 PM for same-day delivery', 'Order tonight for next-day delivery'],
    ['Order by 5PM for same-day delivery', 'Order tonight for next-day delivery'],
    ['Same-Day Delivery Available', 'Next-Day Delivery Available']
  ];
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, OPTION: 1, SELECT: 1 };

  function nyHour() {
    try {
      var h = parseInt(new Date().toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }), 10);
      if (h === 24) { h = 0; }
      return isNaN(h) ? -1 : h;
    } catch (e) { return -1; }
  }

  function swap() {
    var h = nyHour();
    if (h < 17) { return; }
    if (!document.body) { return; }
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (!parent || SKIP[parent.nodeName]) { continue; }
      if (parent.closest && parent.closest('#nt_cart_canvas')) { continue; }
      var text = node.nodeValue;
      if (!text || text.length < 8) { continue; }
      var next = text;
      for (var i = 0; i < PAIRS.length; i++) {
        if (next.indexOf(PAIRS[i][0]) !== -1) { next = next.split(PAIRS[i][0]).join(PAIRS[i][1]); }
      }
      if (next !== text) { node.nodeValue = next; }
    }
  }

  function start() {
    swap();
    setTimeout(swap, 1500);
    setInterval(swap, 300000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { swap(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* MLF v27, 8 Aug 2026: мёртвое кольцо свотчей вариантов (MIDA dead click #nt_select_ppr_0,
   он же источник призрака #cart-form_ppr). Обработчик темы (swatch.min.js) делегирован на
   .swatches-select > .nt-swatch, но клики по кольцу свотча вне внутреннего span до него не доходят.
   Ловим клик по контейнеру .swatch, находим свотч по координатам и пробрасываем клик в span.
   Ничего не делает, если клик уже пришёл в .nt-swatch или свотч выбран/недоступен.
   Откат: убрать этот блок или опубликовать предыдущую тему. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.closest('.nt-swatch')) { return; }
    var box = t.closest('.swatch');
    if (!box) { return; }
    var items = box.querySelectorAll('.swatches-select > .nt-swatch');
    if (!items.length) { return; }
    var x = e.clientX, y = e.clientY;
    if (!x && !y) { return; }
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        if (items[i].classList.contains('is-selected') || items[i].classList.contains('nt_unavailable')) { return; }
        var sp = items[i].querySelector('.swatch__value_pr') || items[i];
        sp.click();
        return;
      }
    }
  });
})();
